import type {
  MapChangeRequest,
  MapPeriodsRequest,
  MapSliceRequest,
  RegionTimeSeriesRequest,
} from "@/features/explorer/api/contracts";

/**
 * Client-side (React Query) cache lifetime for ONS analytics data (~1 month).
 * ONS indicators refresh infrequently, so keep the browser from refetching
 * unless the data is purged explicitly (the map Refresh control) or a cache
 * invalidation rule fires. `gcTime` must stay as long as `staleTime` so a query
 * survives navigation away and back without being garbage collected and
 * refetched.
 */
export const ANALYTICS_STALE_TIME_MS = 30 * 24 * 60 * 60 * 1000;
export const ANALYTICS_GC_TIME_MS = 30 * 24 * 60 * 60 * 1000;

const explorerQueryKeyRoot = ["national-data"] as const;

export const explorerQueryKeys = {
  all: explorerQueryKeyRoot,
  mapSlice: (request: MapSliceRequest) => [...explorerQueryKeyRoot, "map-slice", request] as const,
  mapPeriods: (request: MapPeriodsRequest) => [...explorerQueryKeyRoot, "map-periods", request] as const,
  mapChange: (request: MapChangeRequest) => [...explorerQueryKeyRoot, "map-change", request] as const,
  regionTimeSeries: (request: RegionTimeSeriesRequest) =>
    [...explorerQueryKeyRoot, "region-time-series", request] as const,
};
